import { formatMoney, formatNumber } from "accounting-js";
export function currencyFormat(valueInCents, precision, stripZeros, symbol) {
    if (valueInCents === undefined || valueInCents === null || isNaN(valueInCents)) {
        return "";
    }
    const settings = {
        symbol: symbol || "",
        decimal: ",",
        thousand: ".",
        precision: precision || 2,
        stripZeros: stripZeros || false,
    };
    valueInCents /= 100;
    return formatMoney(valueInCents, settings);
}
export function getEuroFromCurrency(originalAmount, rate) {
    if (rate) {
        return Math.round(originalAmount / rate);
    }
    else {
        return originalAmount || 0;
    }
}
export class CurrencyFormatter {
    static DECIMAL_SEPARATOR = ",";
    static THOUSANDS_SEPARATOR = ".";
    static PRECISION = 2;
    constructor() { }
    static textToCents(text) {
        const num = +text
            .split(CurrencyFormatter.THOUSANDS_SEPARATOR)
            .join("")
            .split(CurrencyFormatter.DECIMAL_SEPARATOR)
            .join(".");
        return +((isNaN(num) ? 0 : num) * 100).toFixed(0);
    }
}
export function numberFormat(value, precision) {
    if (value === null || value === undefined) {
        return "";
    }
    const settings = {
        decimal: ",",
        thousand: ".",
        precision: precision || 2,
    };
    return formatNumber(value, settings);
}
export function weightFormat(value, precision) {
    if (Number.isFinite(value)) {
        return "";
    }
    const settings = {
        decimal: ",",
        thousand: ".",
        precision: precision || 3,
        symbol: "",
    };
    return formatMoney(Number(value), settings);
}
//# sourceMappingURL=currency.js.map